import { render, staticRenderFns } from "./confidentiality-restriction.vue?vue&type=template&id=9632dd62&scoped=true&"
import script from "./confidentiality-restriction.vue?vue&type=script&lang=js&"
export * from "./confidentiality-restriction.vue?vue&type=script&lang=js&"
import style0 from "./confidentiality-restriction.vue?vue&type=style&index=0&id=9632dd62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9632dd62",
  null
  
)

export default component.exports